import React from 'react';
import PropTypes from 'prop-types';

import s from './ModalContent.css';

const ModalContent = props => {
  const { qaId, modalTitle, children,
    modalCloseAction, modalCloseTitle,
    modalConfirmAction, modalConfirmTitle } = props;

  return (
    <div className={s.modal} data-qa={qaId}>
      <div className={s.modalTitle}>{modalTitle}</div>
      <div className={s.modalContent}>
        {children}
      </div>
      <div className={s.modalFooter}>
        <button className="btn text-link" onClick={modalCloseAction}>
          {modalCloseTitle ? modalCloseTitle : 'Cancel'}
        </button>
        {modalConfirmAction &&
          <button className="btn primary" onClick={modalConfirmAction}>
            {modalConfirmTitle ? modalConfirmTitle : 'Confirm'}
          </button>
        }
      </div>
    </div>
  );
};

ModalContent.propTypes = {
  modalTitle: PropTypes.string,
  modalCloseAction: PropTypes.func.isRequired,
  modalCloseTitle: PropTypes.string,
  modalConfirmAction: PropTypes.func,
  modalConfirmTitle: PropTypes.string,
  qaId: PropTypes.string
};

export default ModalContent;